<template>
  <v-container fluid>
    <v-card class="pb-2">
      <v-card-title>Отчет по КЛН операторов (ИИ)</v-card-title>

      <!-- Селекторы -->
      <v-form ref="form">
        <v-card-text>
          <v-row>
            <!-- Дата -->
            <v-col cols="12" sm="6" md="4">
              <date-time-picker v-model="filters.date" />
            </v-col>

            <!-- тип даты (озыв/звонок) -->
            <v-col cols="12" sm="6" md="4">
              <Carusel-Button
                label="По дате"
                :type="'general'"
                :items="[
                  {name: 'Отзыва', id: 'complaint'},
                  {name: 'Звонка', id: 'call'},
                ]"
                :getVal="getValPeriodType"
                style="margin-top:17px;"
              />
            </v-col>

            <!-- Проекты -->
            <v-col cols="12" sm="6" md="4">
              <ProjectSelector v-model="filters.project_ids" />
            </v-col>

            <!-- Тип отзыва -->
            <v-col cols="12" sm="6" md="4">
              <custom-select
                v-model="filters.type_ids"
                :items="questionnaires"
                :loading="questionnairesLoading"
                item-text="label"
                chip-text="label"
                item-value="id"
                label="Тип отзыва"
                multiple
              />
            </v-col>

            <!-- Операторы -->
            <v-col cols="12" sm="6" md="4">
              <UserSelector v-model="filters.user_ids" noRules/>
            </v-col>

            <!-- Автор отзыва -->
            <v-col cols="12" sm="6" md="4">
              <UserSelector v-model="filters.author_ids" noRules label="Автор отзыва" />
            </v-col>

            <!-- Продолжительность -->
            <v-col cols="12" sm="6" md="4">
              <v-row class="mt-0 pl-3">
                <span>Продолжительность (сек.)</span>
              </v-row>
              <v-row no-gutters>
                <v-col cols="6">
                  <v-text-field
                    v-model="filters.duration_range.from"
                    hide-details
                    single-line
                    prefix="От"
                    type="number"
                  />
                </v-col>

                <v-col cols="6" class="pl-2">
                  <v-text-field
                    v-model="filters.duration_range.to"
                    hide-details
                    single-line
                    prefix="До"
                    type="number"
                  />
                </v-col>
              </v-row>
            </v-col>

            <!-- Балл КЛН -->
            <v-col cols="12" sm="6" md="4">
              <v-row class="mt-0 pl-3">
                <span>Балл КЛН</span>
              </v-row>
              <v-row no-gutters>
                <v-col cols="6">
                  <v-text-field
                    v-model="filters.kln_range[0]"
                    hide-details
                    single-line
                    prefix="От"
                    type="number"
                    min="0"
                    max="100"
                  />
                </v-col>

                <v-col cols="6" class="pl-2">
                  <v-text-field
                    v-model="filters.kln_range[1]"
                    hide-details
                    single-line
                    prefix="До"
                    type="number"
                    min="0"
                    max="100"
                  />
                </v-col>
              </v-row>
            </v-col>

            <!-- Только переведённые -->
            <v-col cols="12" sm="6" md="3">
              <v-checkbox
                v-model="filters.only_transfered"
                hide-details
                class="ma-0"
                label="Только переведённые"
              />
              <v-checkbox
                v-model="filters.is_gpt"
                hide-details
                class="ma-0"
                label="Только ИИ отзывы"
              />
            </v-col>


            <v-col align="right">
              <v-btn
                color="success"
                class="mt-3"
                @click="loadReport"
              >Поиск</v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-form>
    </v-card>

    <!-- Результаты -->
    <v-card class="my-5">
      <v-data-table
        :headers="report.headers"
        :items="report.items"
        :items-per-page="report.items.length"
        :loading="tableLoading"
        must-sort
        loading-text="Загрузка..."
        no-data-text="Ничего не найдено"
        dense
        hide-default-footer
      >
        <template #[`item.action`]="{ item }">
          <v-tooltip bottom>
            <template #activator="{ on }">
              <v-btn
                v-on="on"
                icon
                target="_blank"
                :href="complaintsReportUrl(item)"
              >
                <v-icon small>mdi-open-in-new</v-icon>
              </v-btn>
            </template>
            <span>Посмотреть отзывы</span>
          </v-tooltip>
        </template>
      </v-data-table>
    </v-card>

  </v-container>
</template>

<script>
import moment from 'moment'

import { mapActions, mapGetters } from 'vuex'
import ProjectSelector from '~/components/partials/selectors/ProjectSelector'
import UserSelector from '~/components/partials/selectors/UserSelector'

export default {
  name: 'KlnByOperators',
  components: {
    ProjectSelector,
    UserSelector,
  },

  data() {
    return {
      filters: {
        date: {},
        period_type: 'call', // call | complaint
        project_ids: [],
        user_ids: [],
        author_ids: [],
        duration_range: {
          from: 0,
          to: 7200,
        },
        kln_range: [0, 100],
        type_ids: [],
        is_gpt: false,
        only_transfered: false,
      },
      savedFilters: {},
      questionnaires: [],
      questionnairesLoading: true,
      tableLoading: false,

      report: {
        items: [],
        headers: [
          {text: '', value: 'action', sortable: false},
        ],
      }
    }
  },

  computed: {
    ...mapGetters({}),

    addComplaintKLN() {
      // depricated
      let kln = 0

      this.addComplaint.criterias.forEach(item => {
        const criterial = this.criteriasList.find(criteriaItem => criteriaItem.id === item)
        if (criterial !== undefined) kln -= criterial.weight
      })

      if (kln < 0) kln = 0

      return kln
    },

    totalDurationMin() {
      if (this.totalDuration && typeof this.totalDuration === 'number') {
        if (this.totalDuration === 0) return 0
        return Math.floor(this.totalDuration / 60)
      }
      return null
    },
  },

  methods: {
    ...mapActions({
      loadQuestionnaires: 'complaints_report/loadQuestionnaires',
      loadKlnByOperatorsReport: 'kln_by_operators/loadKlnByOperatorsReport',
    }),

    getValPeriodType(data) {
      this.filters.period_type = data
    },

    complaintsReportUrl(item) {
      const filters = {
        ...this.savedFilters,
        user_id: item.user_id,
      }

      delete filters.date
      delete filters.kln_range
      delete filters.user_ids
      filters.duration_range = [filters.duration_range.from, filters.duration_range.to]

      return `${process.env.VUE_APP_API_DOMAIN}${this.$router.resolve({
        name: 'complaints-report',
        query: filters,
      }).href}`
    },

    async loadReport() {
      if (!this.$refs.form.validate()) return
      this.tableLoading = true

      const payload = {
        ...this.filters,
        period: [
          moment(this.filters.date.start).format('YYYY-MM-DD HH:mm:ss'),
          moment(this.filters.date.end).format('YYYY-MM-DD HH:mm:ss')
        ]
      }

      this.savedFilters = JSON.parse(JSON.stringify(payload))

      delete payload.date
      delete payload.only_transfered

      try {
        const data = await this.loadKlnByOperatorsReport(payload)

        this.report.headers = data.headers.map(header => ({
          text: header.title,
          value: header.code,
        }))
        this.report.headers.push({text: '', value: 'action', sortable: false})
        this.report.items = data.items
      } catch (error) {
        console.error(error)
      } finally {
        this.tableLoading = false
      }
    },

    test() {
      console.log(this.filters.date)
    },
  },

  async mounted() {
    this.questionnaires = await this.loadQuestionnaires()
    this.questionnairesLoading = false
  },
}
</script>

<style scoped></style>
